import { SelectFields } from '@repo/toolkit/types'

import { EnrollmentSibling } from '../../models/enrollment-siblings/enrollment-siblings'
import { FieldsSelector } from '../../utils'

export const enrollmentSiblingBasicFields = [
  'id',
  'name',
  'gender',
  'age'
] as const satisfies FieldsSelector<EnrollmentSibling>

export type EnrollmentSiblingBasicType = SelectFields<
  EnrollmentSibling,
  typeof enrollmentSiblingBasicFields
>
